import './design/tokens.css';
import './design/base.css';
import './design/components.css';
import './privacy.css';
import { applyTheme, readStoredTheme } from './lib/theme';

applyTheme(readStoredTheme(localStorage), document.documentElement, localStorage);
